import {
  Activity,
  BarChart3,
  CreditCard,
  LayoutDashboard,
  LifeBuoy,
  Megaphone,
  Settings,
  Share2,
  ShieldCheck,
  Store,
  Users,
  Wallet,
} from "lucide-react";

export const ADMIN_NAV_ITEMS = [
  {
    to: "/",
    label: "Overview",
    description: "Platform metrics and operational activity",
    keywords: "dashboard home revenue metrics",
    icon: LayoutDashboard,
    end: true,
    testid: "nav-overview",
    permission: "overview.view",
  },
  {
    to: "/shops",
    label: "Shops",
    description: "Find and manage registered shops",
    keywords: "merchant business store",
    icon: Store,
    testid: "nav-shops",
    permission: "shops.view",
  },
  {
    to: "/subscriptions",
    label: "Subscriptions",
    description: "Plans, access and renewals",
    keywords: "billing plan trial expired",
    icon: CreditCard,
    testid: "nav-subscriptions",
    permission: "subscriptions.view",
  },
  {
    to: "/payments",
    label: "Payments",
    description: "Transactions and payment exceptions",
    keywords: "transaction failed pending revenue",
    icon: Wallet,
    testid: "nav-payments",
    permission: "payments.view",
  },
  {
    to: "/referrals",
    label: "Referrals",
    description: "Referral performance and rewards",
    keywords: "affiliate rewards",
    icon: Share2,
    testid: "nav-referrals",
    permission: "referrals.view",
  },
  {
    to: "/sales",
    label: "Field & Sales",
    description: "Sales pipeline and field operations",
    keywords: "agents pipeline leads",
    icon: Megaphone,
    testid: "nav-sales",
    permission: "sales.view",
  },
  {
    to: "/support",
    label: "Support",
    description: "Customer tickets and assistance",
    keywords: "tickets help customer",
    icon: LifeBuoy,
    testid: "nav-support",
    permission: "support.view",
  },
  {
    to: "/sync",
    label: "Sync Health",
    description: "Integration status and conflicts",
    keywords: "integration errors conflicts",
    icon: Activity,
    testid: "nav-sync",
    permission: "sync.view",
  },
  {
    to: "/analytics",
    label: "Analytics",
    description: "Performance reports and trends",
    keywords: "reports charts trends",
    icon: BarChart3,
    testid: "nav-analytics",
    permission: "analytics.view",
  },
  {
    to: "/admins",
    label: "Admin Users",
    description: "Administrative accounts and access",
    keywords: "users roles permissions",
    icon: Users,
    testid: "nav-admins",
    permission: "admin_users.view",
  },
  {
    to: "/audit",
    label: "Audit Logs",
    description: "Security and administrative activity",
    keywords: "events history compliance security",
    icon: ShieldCheck,
    testid: "nav-audit",
    permission: "audit.view",
  },
  {
    to: "/settings",
    label: "Settings",
    description: "Console and platform configuration",
    keywords: "configuration preferences",
    icon: Settings,
    testid: "nav-settings",
    permission: "settings.manage",
  },
];

export function visibleAdminNavItems(permissions = []) {
  const allowed = new Set(permissions);
  return ADMIN_NAV_ITEMS.filter((item) => allowed.has(item.permission));
}
